/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'us-west-2',
  aws_cognito_region: 'us-west-2',
  aws_user_pools_id: 'us-west-2_FQpfdm0QF',
  aws_user_pools_web_client_id: '4ohfiba07k15uedtmi3g3vutc',
  oauth: {
    domain: 'pulsarapp.auth.us-west-2.amazoncognito.com',
    scope: ['email', 'openid'],
    // Where users get sent after logging in.
    // will be added to windows.location.origin
    redirectSignIn: '/dashboard',
    // will be added to windows.location.origin.
    redirectSignOut: '/',
    responseType: 'token'
  },
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: '8',
    passwordPolicyCharacters: [
      'REQUIRES_LOWERCASE',
      'REQUIRES_UPPERCASE',
      'REQUIRES_NUMBERS',
      'REQUIRES_SYMBOLS'
    ]
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_cognito_login_mechanisms: ['EMAIL']
};

export default awsmobile;

export const customProvider = 'Okta-test';
